import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Colors } from '../../../../utils/resources/colors';

export interface TellAFriendCSSStyle extends UIComponentCSSStyle
{
    getContactNumberCSSStyle(): object;
    getConfirmButtonCSSStyle(): object;
}

export class TellAFriendCSSStyleImpl extends UIComponentCSSStyleImpl implements TellAFriendCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            paddingBottom:'30px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }

    getContactNumberCSSStyle(): object 
    {
        return {
            width: "100%",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingTop: "10px",
            paddingLeft: "32px",
            paddingRight: "32px",
        };
    }

    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "25px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tellafriend/tellafriendcss.tsx